import React from "react";
import { preferredLocationSelector } from "tsi-common-react/src/apps/common/selectors";
import { useAppDispatch } from "tsi-common-react/src/apps/reducers";
import { useMountEffect } from "tsi-common-react/src/hooks/useMountEffect";

import { useAppSelector } from "../../hooks";
import { FlagshipNearestStores as FlagshipNearestStoresComponent } from "../components/FlagshipNearestStores";
import { flagshipStoreSelector } from "../selectors";
import { loadAllFlagshipStorePages } from "../thunks";

export const FlagshipNearestStores = (props: {
    maxTiles: number;
    includeLocationInfo: boolean;
}): React.ReactNode => {
    const stores = useAppSelector(flagshipStoreSelector);
    const storePages = useAppSelector((state) =>
        Object.values(state.retail.flagshipStorePages),
    );
    const preferredLocation = useAppSelector(preferredLocationSelector);
    const dispatch = useAppDispatch();

    useMountEffect(() => {
        void dispatch(loadAllFlagshipStorePages());
    });

    return (
        <FlagshipNearestStoresComponent
            stores={stores}
            storePages={storePages}
            maxTiles={props.maxTiles}
            preferredLocation={preferredLocation}
            includeLocationInfo={props.includeLocationInfo}
        />
    );
};
